module.exports = __webpack_public_path__ + "static/img/patho-tympanic-lesions-ruptured-eardrum-DII9Cy_q.45dedb68.png";